import React, { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Button, Tooltip, Switch, Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { GreetingNotesQuery } from '../../services/query';
import { useTranslation } from 'react-i18next';
import MenuIcon from '@mui/icons-material/Menu';
import { SCUIGreetingNotsDrawerContent } from './components/SCUIGreetingNotsDrawerContent';
import { SCUIButton } from '../../atomic/atoms';
import { GREETING } from './greetingNotes.classes';

export const GreetingNotes: FC<any> = () => {
    const { t } = useTranslation();
    const [state, setState] = React.useState({
        right: false,
    });
    const [greetingNotes, setGreetingNotes] = React.useState([]);
    const [refresh, setRefresh] = useState(false);
    const [nots, setNots] = React.useState<any>();

    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });

    const refreshSmsTemplate = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    useEffect(() => {
        getGreetingNotes();
    }, [refresh]);

    const columns: ExtendedGridColDef[] = [
        {
            field: 'title',
            headerName: t('greetingNotes.title'),
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div className={GREETING.datagridCellTitle}>
                        <Tooltip title={params.row.title}>
                            <p>{params.row.title}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'text',
            headerName: t('greetingNotes.text'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'isActive',
            headerName: t('greetingNotes.active'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return (
                    <div>
                        <Switch className={GREETING.inputSwitchRowActive} checked={params.row.isActive} />
                        {params.row.isActive}
                    </div>
                );
            },
        },
        {
            field: 'düzenle',
            headerName: t('general.edit'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setNots(params.row);
                    onDrawerOpen();
                };
                return (
                    <div>
                        <Button className={GREETING.inputButtonRowEdit} onClick={onclick}>
                            <MenuIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];
    const getGreetingNotes = () => {
        GreetingNotesQuery.ListGreetingNotes()
            .then((res: any) => {
                if (res) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.id || '-',
                            title: item.title || '-',
                            text: item.text || '-',
                            isActive: item.status,
                        };
                    });
                    setGreetingNotes(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    return (
        <SCUIContent>
            <Box className={GREETING.page}>
                <Grid container spacing={2} className={GREETING.mainGrid}>
                    <Grid
                        className={GREETING.headerSection}
                        size={{
                            lg: 10,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <h1 className="headtxt">{t('greetingNotes.getForMe')}</h1>
                    </Grid>
                    <Grid
                        className={GREETING.actionsToolbar}
                        container
                        justifyContent="flex-end"
                        size={{
                            xs: 12,
                            sm: 12,
                        }}
                    >
                        <SCUIButton
                            className={GREETING.inputButtonAdd}
                            text={t('greetingNotes.addGiftCard')}
                            sizeType="fixed"
                            type="primary"
                            size={'l'}
                            onClick={() => {
                                setNots([]);
                                onDrawerOpen();
                            }}
                        ></SCUIButton>
                    </Grid>
                    <SCUIGeneralDrawer
                        open={state['right']}
                        anchor="right"
                        width={'80rem'}
                        onClose={(event: any, reason: any) => {
                            if (reason === 'backdropClick') {
                                setState({ ...state, right: false });
                            }
                        }}
                    >
                        <SCUIGreetingNotsDrawerContent
                            selectedRow={nots}
                            onCloseMenu={onDrawerClose}
                            onUpdate={refreshSmsTemplate}
                        />
                    </SCUIGeneralDrawer>
                    <Grid className={GREETING.gridWrap} size={{ xs: 12 }}>
                        <SCUICustomDataGrid randomId rows={greetingNotes} columns={columns} />
                    </Grid>
                </Grid>
            </Box>
        </SCUIContent>
    );
};
